import { metafieldFields } from "../fields";

export const brandsMetafield = {
  operation: {
    name: 'metafield(namespace: "type", key: "brands")',
    alias: "brands",
  },
  fields: metafieldFields,
  variables: {},
};

export const tagMetafield = {
  operation: {
    name: 'metafield(namespace: "operation", key: "tag")',
    alias: "tag",
  },
  fields: metafieldFields,
  variables: {},
};

export const typeMetafield = {
  operation: {
    name: 'metafield(namespace: "collection", key: "type")',
    alias: "type",
  },
  fields: metafieldFields,
  variables: {},
};

export const membershipMetafield = {
  operation: {
    name: 'metafield(namespace: "custom", key: "accessible_memberships")',
    alias: "accessible_memberships",
  },
  fields: metafieldFields,
  variables: {},
};
